
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./BannerVolta": function() {
return __webpack_require__.e("78").then(function() { return function() { return __webpack_require__(2920); }; });
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };